// This file is generated by scripts/generate-build-info.js
// Do not edit manually.

export const buildId = "dpl_FD3Cy7z95YFMFCedS6JwXs5G6oZw" as const;
export const builtAt = "2026-11-04T21:44:14.871Z" as const;
export const vercelEnv: string | null = "preview";
export const gitCommitSha: string | null = "16de8e8d0ec95cefc1db218f6f99cfecd70d0c40";
export const deploymentId: string | null = "dpl_FD3Cy7z95YFMFCedS6JwXs5G6oZw";
